import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Configuración de Firebase - REEMPLAZA CON TUS DATOS
const firebaseConfig = {
  apiKey: "AIzaSyBxSM5aMIDVnv3D3uMKW3ovVanJtMQ3hQM",
  authDomain: "talonariorifa.firebaseapp.com",
  projectId: "talonariorifa",
  storageBucket: "talonariorifa.firebasestorage.app",
  messagingSenderId: "908208703065",
  appId: "1:908208703065:web:8a5e5a4fe75c23fd1b1348"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar servicios
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
